
import React from 'react';

const AuthHeader: React.FC = () => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-3xl font-bold text-brandBlue mb-2">FeedMyBack</h1>
      <p className="text-gray-600">Créez un compte ou connectez-vous pour continuer</p>
    </div>
  );
};

export default AuthHeader;
